import React, { useEffect } from 'react';

/**
 * TermsAdminPage — 가맹점(스토어 운영자) 전용 서비스 이용약관.
 * 고객용 약관과 분리되어 플랫폼 수수료, 정산 주기, 해지 등을 명시합니다.
 */
export default function TermsAdminPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-container" style={{ padding: '40px 40px 80px', maxWidth: 860, margin: '0 auto' }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: 'var(--text)', letterSpacing: '-0.5px', marginBottom: 8 }}>
          가맹점 서비스 이용약관
        </h1>
        <p style={{ fontSize: 13, color: 'var(--text-tertiary)' }}>
          최종 개정일: 2026년 1월 1일 · 시행일: 2026년 1월 1일
        </p>
      </div>

      <div
        style={{
          background: 'var(--surface)',
          borderRadius: 16,
          padding: 32,
          boxShadow: 'var(--shadow-sm)',
        }}
      >
        <S title="제1조 (목적)">
          본 약관은 스마트오더(이하 "회사")가 운영하는 QR 주문 플랫폼(이하 "서비스")을 이용하고자 하는 음식점, 카페 등
          사업자(이하 "가맹점")와 회사 간의 권리, 의무 및 책임사항, 이용조건 및 절차, 수수료, 정산 방법 등을 규정함을
          목적으로 합니다.
        </S>

        <S title="제2조 (정의)">
          <Ol>
            <li>"가맹점"이란 본 약관에 따라 회사와 서비스 이용 계약을 체결하고 서비스를 이용하는 사업자를 의미합니다.</li>
            <li>"플랫폼"이란 회사가 운영하는 QR 주문, 결제, 정산, 매장 관리 기능을 제공하는 온라인 시스템 일체를 의미합니다.</li>
            <li>"결제대행사(PG)"란 가맹점과 고객 간의 결제를 중개하는 전자금융거래법상 등록된 사업자를 의미합니다.</li>
            <li>"정산"이란 회사가 고객으로부터 수령한 상품 대금에서 수수료 및 기타 공제액을 차감하여 가맹점에게 지급하는 절차를 의미합니다.</li>
          </Ol>
        </S>

        <S title="제3조 (이용 계약의 성립)">
          <Ol>
            <li>이용 계약은 가맹점이 회사가 정한 절차에 따라 회원가입을 신청하고, 회사가 이를 승낙함으로써 성립합니다.</li>
            <li>회사는 다음 각 호에 해당하는 경우 승낙을 거부하거나 사후에 이용 계약을 해지할 수 있습니다.
              <Ul>
                <li>허위 또는 타인의 명의로 신청한 경우</li>
                <li>사업자 등록이 유효하지 않은 경우</li>
                <li>과거 회사와의 계약을 부정한 방법으로 위반한 이력이 있는 경우</li>
                <li>기타 법령 및 본 약관에 반하는 경우</li>
              </Ul>
            </li>
          </Ol>
        </S>

        <S title="제4조 (서비스 내용)">
          <p>회사는 가맹점에게 아래와 같은 서비스를 제공합니다.</p>
          <Ol>
            <li>QR 코드 기반의 테이블 주문 접수 및 관리 기능</li>
            <li>메뉴, 카테고리, 옵션 관리 도구</li>
            <li>결제 대행사 연동을 통한 카드, 간편결제 수납 기능</li>
            <li>매출 통계 및 리포트 제공</li>
            <li>직원 호출, 쿠폰, 테이블 관리 등 부가 기능</li>
            <li>정산 및 송금 서비스</li>
          </Ol>
        </S>

        <S title="제5조 (수수료 및 결제 대행)">
          <Ol>
            <li>가맹점은 서비스 이용의 대가로 회사가 정하는 수수료를 부담합니다. 기본 수수료는 거래 금액의 3.0%이며, 카드 수수료(2.5%)와 플랫폼 이용료(0.5%)를 합한 금액입니다.</li>
            <li>수수료율은 시장 환경, 결제 수단, 매출 규모 등에 따라 변동될 수 있으며, 변경 시 최소 30일 전에 사전 공지합니다.</li>
            <li>결제 대행은 회사가 지정한 전자금융거래법상 등록된 결제대행사를 통하여 이루어지며, 결제 승인 및 취소 내역은 가맹점 관리자 화면에서 확인할 수 있습니다.</li>
            <li>특정 결제 수단(예: 간편결제)에 대하여는 별도의 수수료가 추가될 수 있습니다.</li>
          </Ol>
        </S>

        <S title="제6조 (정산)">
          <Ol>
            <li>회사는 주간 정산을 원칙으로 합니다. 월요일부터 일요일까지의 매출을 그 다음 주 수요일에 가맹점 명의의 계좌로 송금합니다.</li>
            <li>정산 금액은 해당 기간의 매출에서 수수료, 환불 금액, 기타 공제액(분쟁 유보금 등)을 차감한 금액으로 계산됩니다.</li>
            <li>공휴일 또는 금융기관 휴무일이 포함된 경우 정산 일정은 다음 영업일로 이월됩니다.</li>
            <li>가맹점이 등록한 계좌 정보가 사실과 다르거나 송금이 반송된 경우, 회사는 즉시 가맹점에 통지하고 정정 후 재송금합니다. 이로 인한 송금 지연의 책임은 가맹점에 있습니다.</li>
            <li>분쟁이 발생한 주문에 대해서는 분쟁 해결 시까지 해당 금액을 유보할 수 있습니다.</li>
          </Ol>
        </S>

        <S title="제7조 (환불 및 주문 취소)">
          <Ol>
            <li>가맹점은 고객이 환불을 요청한 경우 환불정책에 따라 신속하게 처리하여야 합니다.</li>
            <li>조리 시작 전 주문 취소 또는 매장 귀책사유에 의한 환불의 경우 전액 환불이 원칙입니다.</li>
            <li>환불된 금액은 당해 주간 정산 금액에서 차감되며, 이미 정산이 완료된 경우에는 익주 정산 금액에서 공제됩니다.</li>
            <li>가맹점의 부당한 환불 거부 또는 지연으로 인한 민원은 회사의 분쟁 조정 절차에 따라 처리되며, 반복되는 경우 이용 제한 사유가 될 수 있습니다.</li>
          </Ol>
        </S>

        <S title="제8조 (가맹점의 의무)">
          <Ol>
            <li>가맹점은 등록한 매장 정보, 메뉴, 가격 등이 사실과 일치하도록 유지하여야 합니다.</li>
            <li>가맹점은 관련 법령(식품위생법, 전자상거래법 등)을 준수하여야 합니다.</li>
            <li>가맹점은 고객의 개인정보를 수집·이용한 경우 개인정보보호법에 따라 안전하게 관리하여야 합니다.</li>
            <li>가맹점은 서비스를 부정한 방법으로 이용하거나 타인의 권리를 침해하여서는 아니 됩니다.</li>
            <li>가맹점은 계정 정보(아이디, 비밀번호)를 제3자에게 양도, 대여하여서는 아니 됩니다.</li>
          </Ol>
        </S>

        <S title="제9조 (회사의 의무)">
          <Ol>
            <li>회사는 서비스를 안정적으로 제공하기 위하여 최선을 다합니다.</li>
            <li>회사는 가맹점의 정보를 법령에 근거한 경우를 제외하고는 제3자에게 제공하지 않습니다.</li>
            <li>회사는 가맹점의 문의에 신속하고 성실하게 응답합니다.</li>
          </Ol>
        </S>

        <S title="제10조 (서비스의 중단)">
          <Ol>
            <li>회사는 컴퓨터, 통신 설비의 보수, 교체, 정기 점검 등의 사유가 발생한 경우 서비스 제공을 일시적으로 중단할 수 있으며, 이 경우 최소 24시간 전에 공지합니다.</li>
            <li>불가항력(천재지변, 전쟁, 국가 비상사태 등) 또는 기간통신사업자의 서비스 중지 등으로 서비스 제공이 불가능한 경우에는 책임이 면제됩니다.</li>
          </Ol>
        </S>

        <S title="제11조 (계약 해지)">
          <Ol>
            <li>가맹점은 언제든지 관리자 화면의 계약 해지 기능 또는 고객센터를 통하여 서비스 이용을 종료할 수 있습니다.</li>
            <li>회사는 가맹점이 본 약관을 위반하거나 법령을 위반하는 경우, 사전 통지 후 이용 계약을 해지할 수 있습니다.</li>
            <li>계약이 해지된 경우 회사는 미정산 금액을 최종 정산일에 송금하며, 이후 발생한 분쟁에 대하여는 가맹점이 책임집니다.</li>
          </Ol>
        </S>

        <S title="제12조 (손해배상 및 면책)">
          <Ol>
            <li>회사는 서비스의 이용과 관련하여 가맹점이 입은 직접적인 손해 중 회사의 고의 또는 중대한 과실에 기인한 것에 대하여 배상 책임을 집니다.</li>
            <li>회사는 간접 손해, 특별 손해, 일실 이익에 대하여는 책임지지 않습니다.</li>
            <li>회사의 총 배상 책임 한도는 사고 발생 직전 3개월간 가맹점이 회사에 지급한 수수료 총액을 초과하지 않습니다.</li>
          </Ol>
        </S>

        <S title="제13조 (준거법 및 관할)">
          본 약관은 대한민국 법률에 따라 해석되며, 회사와 가맹점 사이에 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제기합니다.
        </S>

        <S title="부칙">
          <Ol>
            <li>본 약관은 2026년 1월 1일부터 시행합니다.</li>
            <li>본 약관 시행 이전 가입한 가맹점에 대하여도 본 약관이 적용됩니다.</li>
          </Ol>
        </S>
      </div>
    </div>
  );
}

function S({ title, children }) {
  return (
    <section style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 17, fontWeight: 800, color: 'var(--text)', marginBottom: 10 }}>{title}</h2>
      <div style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.8 }}>
        {children}
      </div>
    </section>
  );
}

function Ol({ children }) {
  return (
    <ol style={{ paddingLeft: 22, marginTop: 6 }}>
      {React.Children.map(children, (child) => (
        <li style={{ marginBottom: 6, lineHeight: 1.8 }}>{child}</li>
      ))}
    </ol>
  );
}

function Ul({ children }) {
  return (
    <ul style={{ paddingLeft: 22, marginTop: 6 }}>
      {React.Children.map(children, (child) => (
        <li style={{ marginBottom: 4, lineHeight: 1.8 }}>{child}</li>
      ))}
    </ul>
  );
}
